/**
 * @Relay no-runtime
 */
/**
 * @graphql cc
 */
import graphql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError';
import { isNotFoundError } from '@confluence/error-boundary/entry-points/isNotFoundError';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient';

import type { usePremiumGatePremiumGateQuery as usePremiumGatePremiumGateQuery$data } from './__types__/usePremiumGatePremiumGateQuery';

export const usePremiumGate = () => {
	const { edition } = useSessionData();
	const canSkipEntitlementCheck = edition === ConfluenceEdition.PREMIUM;

	const { data, error } = useQuery<usePremiumGatePremiumGateQuery$data>(
		graphql`
			query usePremiumGatePremiumGateQuery {
				entitlements {
					premiumExtensions {
						isEntitled
					}
				}
			}
		`,
		{
			skip: canSkipEntitlementCheck,
		},
	);

	if (error) {
		if (!(isUnauthorizedError(error) || isNotFoundError(error))) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.COMPANY_HUB,
			});
		}
		markErrorAsHandled(error);
	}

	return !canSkipEntitlementCheck && !data?.entitlements.premiumExtensions.isEntitled;
};
